/**
 * Logo — componente customizado do odc
 *
 * Renderiza o logo do portal ODC.
 * Prioridade: site-logo configurado no Plone > asset estático fallback.
 *
 * Para substituir o logo via CMS, configure em:
 *   Plone control panel → Site → Site logo
 */
import { defineMessages, useIntl } from 'react-intl';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { getNavroot } from '@plone/volto/actions/navroot/navroot';
import { flattenToAppURL, getBaseUrl } from '@plone/volto/helpers/Url/Url';
import { hasApiExpander } from '@plone/volto/helpers/Utils/Utils';
import Image from '@plone/volto/components/theme/Image/Image';

import LogoFallback from './Logo.png';

const messages = defineMessages({
  home: {
    id: 'Home',
    defaultMessage: 'Home',
  },
  logoAlt: {
    id: 'odc.logo.alt',
    defaultMessage: 'ODC logo',
  },
});

const Logo = () => {
  const pathname = useLocation().pathname;
  const navroot = useSelector((state: any) => state.navroot.data);
  const dispatch = useDispatch();
  const intl = useIntl();

  useEffect(() => {
    if (pathname && !hasApiExpander('navroot', getBaseUrl(pathname))) {
      dispatch(getNavroot(getBaseUrl(pathname)));
    }
  }, [dispatch, pathname]);

  const navRootPath = flattenToAppURL(navroot?.navroot?.['@id']) || '/';
  const logoSrc = LogoFallback;

  return (
    <Link
      to={navRootPath}
      aria-label={intl.formatMessage(messages.home)}
      className="odc-logo"
    >
      <Image
        src={logoSrc}
        alt={intl.formatMessage(messages.logoAlt)}
        className="odc-logo__image"
      />
    </Link>
  );
};

export default Logo;
